import type { CampaignData } from '@/schemas/v2/campaign'

/**
 * キャンペーンで言語切替 UI（ヘッダーの言語ボタン）を出すかどうか。
 *
 * - 対応言語が 2 件以上あり、かつ isLocalize で明示的に無効化されていない場合に true
 * - isLocalize が null（未設定）のときは対応言語数だけで判定する
 * - campaignData が未取得（null / undefined）のときは false（ロード中にボタンだけ先に出さない）
 */
export function isLanguageSwitchable(
  campaignData: Pick<CampaignData, 'language' | 'isLocalize'> | null | undefined,
): boolean {
  if (!campaignData) return false
  return campaignData.language.length > 1 && campaignData.isLocalize !== false
}
